import { ImportError } from '../io/errors';
import { importShare } from '../io/import';
import { parseHash } from '../io/share-url';
import type { HydrateContext } from '../io/wire';
import type { KinklistDoc } from '../model/types';
import { importErrors } from '../strings';

export interface RouteHandlers {
  offer: (doc: KinklistDoc) => void;
  fail: (message: string) => void;
  /** Legacy v2 view links (`#<imgurId>`). */
  imgur?: (id: string) => void;
}

/**
 * Handles a share link (`#/s/<payload>`) or legacy link in the URL, then
 * clears the fragment so a reload doesn't import again (SPEC §6.8).
 */
export function handleLocation(
  location: Pick<Location, 'hash' | 'pathname' | 'search'>,
  history: Pick<History, 'replaceState'>,
  ctx: HydrateContext,
  handlers: RouteHandlers,
): void {
  const route = parseHash(location.hash);
  if (route.kind === 'none') return;
  history.replaceState(null, '', `${location.pathname}${location.search}`);
  if (route.kind === 'imgur') {
    handlers.imgur?.(route.id);
    return;
  }
  try {
    handlers.offer(importShare(route.payload, ctx));
  } catch (error) {
    handlers.fail(importErrorMessage(error));
  }
}

export function importErrorMessage(error: unknown): string {
  return error instanceof ImportError ? importErrors[error.code] : importErrors.corrupt;
}
